export const environment = {
  production: true,
  apiBaseUrl: 'https://api.thoroughworks.com/api/v2',
  portalUrl: 'https://portal.thoroughpacs.com',
  siteBase: 'https://tw-repo-b0c6aaebhxbrawhe.eastus2-01.azurewebsites.net',
  api2BaseUrl: 'https://tw-repo-b0c6aaebhxbrawhe.eastus2-01.azurewebsites.net',
  apiAuthUrl: 'https://tw-auth-gahdf6fyejhxdvam.eastus2-01.azurewebsites.net',
  dicomViewer: 'https://viewer.thoroughpacs.com/viewer',
  isSubmissionRestrictionEnabled: false
};
